import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { IMAGES } from "@/data/site";

const FEATURES = [
  "Fire Prevention", "Fire Extinguisher Use", "Practical Fire-Fighting",
  "Emergency Evacuation", "Fire Warden Training", "CERT Awareness",
  "Emergency Response Training", "Table-Top Exercises", "Fire Emergency Drills",
];

export default function FireFeature() {
  return (
    <section className="relative overflow-hidden bg-navy-deep" data-testid="fire-feature-section">
      <div className="pointer-events-none absolute inset-0 bg-blueprint-dark opacity-30" />
      <div className="container-sky grid items-center gap-12 py-20 lg:grid-cols-2 lg:gap-16 lg:py-28">
        {/* Copy */}
        <div>
          <Reveal>
            <span className="tech-tag text-brand-light">Fire Safety & Emergency Response</span>
            <h2 className="mt-4 font-heading text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
              Be Prepared Before an Emergency Happens
            </h2>
            <p className="mt-6 text-base leading-relaxed text-slate-300 sm:text-lg">
              The organisations that respond best are the best prepared. SKY focuses on prevention,
              preparation, response capability and practical, hands-on training — so your people know
              exactly what to do when it matters most.
            </p>
          </Reveal>

          <motion.ul
            initial="hidden" whileInView="show" viewport={{ once: true }}
            variants={{ show: { transition: { staggerChildren: 0.05 } } }}
            className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2"
          >
            {FEATURES.map((f) => (
              <motion.li
                key={f}
                variants={{ hidden: { opacity: 0, x: -12 }, show: { opacity: 1, x: 0 } }}
                className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3"
              >
                <Check className="h-4 w-4 shrink-0 text-brand-light" strokeWidth={3} />
                <span className="text-sm font-medium text-white">{f}</span>
              </motion.li>
            ))}
          </motion.ul>

          <Reveal delay={0.2}>
            <Link to="/services/fire-safety-training" className="btn-primary-sky mt-9 !bg-white !text-navy hover:!bg-brand-light">
              Enquire About Fire Safety Training <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>

        {/* Image */}
        <Reveal delay={0.1} className="relative">
          <div className="relative overflow-hidden rounded-[1.8rem] shadow-[0_30px_80px_rgba(0,0,0,0.4)]">
            <img
              src={IMAGES.fireResponse}
              alt="Fire safety emergency response training exercise in Singapore"
              className="aspect-[4/5] w-full object-cover sm:aspect-square"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/60 to-transparent" />
          </div>
          <div className="absolute -left-4 -top-4 h-16 w-16 rounded-tl-3xl border-l-2 border-t-2 border-brand-light/50" />
        </Reveal>
      </div>
    </section>
  );
}
